const absURLRegex = /^http(s?):\/\/(?<url>.+)/
const ASSET_CDN = 'https://avatar.sumi.io'

export function avatarUrl(url?: string | null): string | null {
  if (url == null) {
    return null
  }

  if (url.match(absURLRegex)) {
    return url
  } else {
    return `${ASSET_CDN}/${url}!apache`
  }
}

export function toDateString(date?: Date | string): string | null {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
}

export function numberWithCommas(x: number): string {
  return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
